module.exports = __webpack_public_path__ + "img/brush-redD.b16089d7.png";